/**
 * SWISS tier badge — a colour-coded pill naming a school's programme
 * tier (SWISS Bridge / Lite / Essentials / Compliance / Complete).
 * The colour comes from the tier model (src/services/tiers.js) so a
 * school's tier is identifiable at a glance wherever it appears.
 */

import React from 'react';
import { tierLabel, tierColor } from '../services/tiers';
import './TierBadge.css';

const TierBadge = ({ tier, size = 'md', dot = false }) => {
  const color = tierColor(tier);
  return (
    <span
      className={`swiss-tier-badge swiss-tier-badge-${size}`}
      style={{ color, background: `${color}1f`, borderColor: `${color}59` }}
    >
      {dot && <span className="swiss-tier-badge-dot" style={{ background: color }} />}
      {tierLabel(tier)}
    </span>
  );
};

export default TierBadge;
